// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"b20cf58c","453":"55b25364","486":"4ab9e1b8","907":"ae13569c"}[chunkId] + ".chunk.js";
};